/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiChannelDefaultFromJSON, ApiChannelDefaultToJSON, } from './ApiChannelDefault';
import { ApiChannelGroupFromJSON, ApiChannelGroupToJSON, } from './ApiChannelGroup';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
export function ApiChannelFromJSON(json) {
    return ApiChannelFromJSONTyped(json, false);
}
export function ApiChannelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'channelGroups': !exists(json, 'channelGroups') ? undefined : (json['channelGroups'].map(ApiChannelGroupFromJSON)),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        '_default': !exists(json, 'default') ? undefined : ApiChannelDefaultFromJSON(json['default']),
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (new Date(json['deletedAt'])),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'isPaidChannel': !exists(json, 'isPaidChannel') ? undefined : json['isPaidChannel'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiChannelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'channelGroups': value.channelGroups === undefined ? undefined : (value.channelGroups.map(ApiChannelGroupToJSON)),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'default': ApiChannelDefaultToJSON(value._default),
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'id': value.id,
        'isPaidChannel': value.isPaidChannel,
        'name': value.name,
        'priority': value.priority,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
